export default __webpack_public_path__ + "static/1558-d427d6f2f385105d57836a8b71d52fc7.gif";